import React, { useEffect, useState } from 'react';
import { Collapsible } from '@homeexchange/design';
import { ReverseSearchByLocation } from './reverseSearchByLocation';
import { ReverseSearchByHomes } from './reverseSearchByHomes';
import i18n from '../../../../i18n';
import styles from './reverseSearch.module.scss';
export var ReverseSearch = function (_a) {
    var onChange = _a.onChange, filters = _a.filters, homes = _a.homes;
    var _b = useState(true), layerSearchDisabled = _b[0], setLayerSearchDisabled = _b[1];
    useEffect(function () {
        var hasReverseSearchByHomes = filters.reverse && filters.reverse.length > 0;
        setLayerSearchDisabled(hasReverseSearchByHomes);
    }, [filters]);
    return (React.createElement("div", { className: styles['container'] },
        React.createElement(ReverseSearchByHomes, { onChange: onChange, filters: filters, homes: homes }),
        React.createElement(Collapsible, { isOpen: false, labelOpen: i18n.t('search:filter.reverseCollapsible'), labelClosed: i18n.t('search:filter.reverseCollapsible'), openOn: "bottom" },
            React.createElement(ReverseSearchByLocation, { onChange: onChange, filters: filters, isDisabled: layerSearchDisabled }))));
};
